import { render, staticRenderFns } from "./ClassSelect.vue?vue&type=template&id=ec537608&scoped=true"
import script from "./ClassSelect.vue?vue&type=script&lang=js"
export * from "./ClassSelect.vue?vue&type=script&lang=js"
import style0 from "./ClassSelect.vue?vue&type=style&index=0&id=ec537608&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec537608",
  null
  
)

export default component.exports